export default {
  ENKRYPT: 'Enkrypt',
  BROWSER_EXTENSION: 'BrowserExtension',
  MOBILE_APPS: 'MobileApps',
  HARWARE_WALLETS: 'HardwareWallets',
  SOFTWARE: 'Software',
  CLOSE_SOFTWARE_ACCESS: 'CloseSoftwareAccess',
  CLOSE_HARDWARE_ACCESS: 'CloseHardwareAccess',
  CLOSE_MOBILE_ACCESS: 'CloseMobileAccess',
  WEB3_ACCESS_SUCCESS: 'Web3AccessSuccess',
  SOFTWARE_BACK: 'SoftwareBack',
  KEYSTORE_SHOWN: 'KeystoreShown',
  MNEMONIC_SHOWN: 'MnemonicShown',
  PRIVATE_KEY_SHOWN: 'PrivateKeyShown',
  KEYSTORE_CONNECTED: 'KeystoreConnected',
  MNEMONIC_CONNECTED: 'MnemonicConnected',
  PRIVATE_KEY_CONNECTED: 'PrivateKeyConnected',
  WALLET_CONNECT_QR_SHOWN: 'MobileAppsWalletConnectQRShown',
  WALLET_CONNECT_QR_SUCCESSFUL: 'MobileAppsWalletConnectQRShownSuccessful',
  WALLET_CONNECT_QR_FAILED: 'MobileAppsWalletConnectQRShownFailed',
  WALLET_LINK_QR_SHOWN: 'MobileAppsWalletLinkQRShown',
  WALLET_LINK_QR_SUCCESSFUL: 'MobileAppsWalletLinkQRSuccessful',
  WALLET_LINK_QR_FAILED: 'MobileAppsWalletLinkQRFailed',
  MEW_WALLET_QR_SHOWN: 'MobileAppsMEWWalletQRShown',
  MEW_WALLET_QR_SUCCESSFUL: 'MobileAppsMEWWalletQRSuccess',
  MEW_WALLET_QR_FAILED: 'MobileAppsMEWWalletQRFailed',
  HW_LEDGER_CLICKED: 'HWLedgerClicked',
  HW_TREZOR_CLICKED: 'HWTrezorClicked',
  HW_KEEPKEY_CLICKED: 'HWKeepKeyClicked',
  HW_BITBOX02_CLICKED: 'HWBitBox02Clicked',
  HW_COOL_WALLET_CLICKED: 'HWCoolWalletClicked',
  HW_BITBOX02_SHOWN: 'HWBitBox02Shown',
  HW_LEDGER_SHOWN: 'HWLedgerShown',
  HW_COOL_WALLET_SHOWN: 'HWCoolWalletShown',
  HW_TREZOR_SHOWN: 'HWTrezorShown',
  HW_KEEPKEY_SHOWN: 'HWKeepKeyShown',
  HW_LEDGER_CONNECTED: 'HWLedgerConnected',
  HW_TREZOR_CONNECTED: 'HWTrezorConnected',
  HW_COOL_WALLET_CONNECTED: 'HWCoolWalletConnected',
  HW_BITBOX02_CONNECTED: 'HWBitBox02Connected',
  HW_KEEPKEY_CONNECTED: 'HWKeepKeyConnected',
  ACCESS_FAILED: 'Failed',
  PRIV_KEY_TERMS: 'PrivateKeyTermsAccepted',
  PRIV_INVISIBLE_BOX: 'PrivateKeyInvisibleBox',
  SOFTWARE_FAILED: 'SoftwareFailed',
  HW_FAILED: 'HWFailed'
};
